<app-spinner></app-spinner>

<div class="row mx-auto" style="min-height: 40vh" *ngIf="this.filterForm">

  <div class="col-lg-1"></div>

  <div class="filter-sidebar col-12 col-lg-3 mb-5 pt-5">

    <form [formGroup]="filterForm!">

      <div class="bg-white rounded mb-3 pb-2">

        <h4 class="sidebar-link pointer p-2" (click)="isCollapsedSearch = !isCollapsedSearch"
            [attr.aria-expanded]="!isCollapsedSearch">
          Suche
          <fa-icon [icon]="isCollapsedSearch ? caretup : caretdown"></fa-icon>
        </h4>

        <input formControlName="search" class="form-control w-90 mx-auto" type="search" placeholder="Suchbegriff" aria-label="Search">
      </div>

      <div class="bg-white rounded mb-3 pb-2" *ngIf="this.contracttypes">

        <h4 class="sidebar-link pointer p-2" (click)="isCollapsedContract = !isCollapsedContract"
            [attr.aria-expanded]="!isCollapsedContract">
          Vertragsart
          <fa-icon [icon]="isCollapsedContract ? caretup : caretdown"></fa-icon>
        </h4>
        <hr class="mx-auto w-90" *ngIf="!isCollapsedContract">
        <ul [(ngbCollapse)]="isCollapsedContract">
          <li *ngFor="let contracttype of this.getFormArray('contract_type').controls; index as i">
            <label formArrayName="contract_type">
              <input type="checkbox" [formControlName]="i"
                     (click)="this.updateQuery({contract_type: this.contracttypes![i].filtername}, {contract_type: null}, 'contract_type', this.contracttypes![i].filtername)">
              {{ this.contracttypes![i].displayname }}
            </label>
          </li>
        </ul>
      </div>

      <div class="bg-white rounded mb-3 pb-2" *ngIf="this.timemodels">

        <h4 class="sidebar-link pointer p-2" (click)="isCollapsedTimeModel = !isCollapsedTimeModel"
            [attr.aria-expanded]="!isCollapsedTimeModel">
          Arbeitszeitmodell
          <fa-icon [icon]="isCollapsedTimeModel ? caretup : caretdown"></fa-icon>
        </h4>
        <hr class="mx-auto w-90" *ngIf="!isCollapsedTimeModel">
        <ul [(ngbCollapse)]="isCollapsedTimeModel">
          <li *ngFor="let timemodel1 of this.getFormArray('timemodel').controls; index as i">
            <label formArrayName="timemodel">
              <input type="checkbox" [formControlName]="i"
                     (click)="this.updateQuery({timemodel: this.timemodels![i].filtername}, {timemodel: null}, 'timemodel', this.timemodels![i].filtername)">
              {{ this.timemodels![i].displayname }}
            </label>
          </li>
        </ul>

      </div>

      <div class="bg-white rounded mb-3 pb-2" *ngIf="this.remote">

        <h4 class="sidebar-link pointer p-2" (click)="isCollapsedRemote = !isCollapsedRemote"
            [attr.aria-expanded]="!isCollapsedRemote">
          Remote
          <fa-icon [icon]="isCollapsedRemote ? caretup : caretdown"></fa-icon>
        </h4>
        <hr class="mx-auto w-90" *ngIf="!isCollapsedRemote">
        <ul [(ngbCollapse)]="isCollapsedRemote">
          <li *ngFor="let remote1 of this.getFormArray('remote').controls; index as i">
            <label formArrayName="remote">
              <input type="checkbox" [formControlName]="i"
                     (click)="this.updateQuery({remote: this.remote![i].filtername}, {remote: null}, 'remote', this.remote![i].filtername)">
              {{ this.remote![i].displayname }}
            </label>
          </li>
        </ul>

      </div>

      <div class="bg-white rounded mb-3 pb-2" *ngIf="this.industry">

        <h4 class="sidebar-link pointer p-2" (click)="isCollapsedBranche = !isCollapsedBranche"
            [attr.aria-expanded]="!isCollapsedBranche">
          Branche
          <fa-icon [icon]="isCollapsedBranche ? caretup : caretdown"></fa-icon>
        </h4>
        <hr class="mx-auto w-90" *ngIf="!isCollapsedBranche">
        <ul [(ngbCollapse)]="isCollapsedBranche">
          <li *ngFor="let branche1 of this.getFormArray('industry').controls; index as i">
            <label formArrayName="industry">
              <input type="checkbox" [formControlName]="i"
                     (click)="this.updateQuery({industry: this.industry![i].filtername}, {industry: null}, 'industry', this.industry![i].filtername)">
              {{ this.industry![i].displayname }}
            </label>
          </li>
        </ul>
      </div>

      <div class="bg-white rounded mb-3 pb-2" *ngIf="this.carrerlevel">

        <h4 class="sidebar-link pointer p-2" (click)="isCollapsedCarrerLevel = !isCollapsedCarrerLevel"
            [attr.aria-expanded]="!isCollapsedCarrerLevel">
          Karrierelevel
          <fa-icon [icon]="isCollapsedCarrerLevel ? caretup : caretdown"></fa-icon>
        </h4>
        <hr class="mx-auto w-90" *ngIf="!isCollapsedCarrerLevel">
        <ul [(ngbCollapse)]="isCollapsedCarrerLevel">
          <li *ngFor="let carrerlevel1 of this.getFormArray('carrerlevel').controls; index as i">
            <label formArrayName="carrerlevel">
              <input type="checkbox" [formControlName]="i"
                     (click)="this.updateQuery({carrerlevel: this.carrerlevel![i].filtername}, {carrerlevel: null}, 'carrerlevel', this.carrerlevel![i].filtername)">
              {{ this.carrerlevel![i].displayname }}
            </label>
          </li>
        </ul>
      </div>

      <div class="bg-white rounded mb-3 pb-2" *ngIf="this.education">

        <h4 class="sidebar-link pointer p-2" (click)="isCollapsedEducation = !isCollapsedEducation"
            [attr.aria-expanded]="!isCollapsedEducation">
          Bildungsstand
          <fa-icon [icon]="isCollapsedEducation ? caretup : caretdown"></fa-icon>
        </h4>
        <hr class="mx-auto w-90" *ngIf="!isCollapsedEducation">
        <ul [(ngbCollapse)]="isCollapsedEducation">
          <li *ngFor="let education1 of this.getFormArray('education').controls; index as i">
            <label formArrayName="education">
              <input type="checkbox" [formControlName]="i"
                     (click)="this.updateQuery({education: this.education![i].filtername}, {education: null}, 'education', this.education![i].filtername)">
              {{ this.education![i].displayname }}
            </label>
          </li>
        </ul>
      </div>

    </form>

  </div>


  <div class="col-12 col-lg-7">

    <h4 *ngIf="this.resultsize === 0 && !(this.loader.isLoading$ | async)">Aktuell gibt es hier leider nichts zu sehen,
      schauen Sie doch gerne später nochmal vorbei</h4>

    <div class="custom-card rounded bg-white" style="padding: 15px; margin-top: 30px; margin-bottom: 30px"
         *ngFor="let job of this.jobs | async">
      <h2 class="custom-card-title">{{ job.title }}</h2>
      <p class="custom-card-description" [innerHTML]="job.description + '<br/><br/>' | safeHtml"></p>

      <div class="row">

        <div class="custom-card-list-location col-12 col-md-auto" *ngIf="this.job!.zipcode && this.job!.city">
          <fa-icon [icon]="mapmarker"></fa-icon>
          <span> {{ job!.zipcode + ", " + job!.city + (job!.district ? " - " + job!.district : "")}}</span>
        </div>

        <div class="custom-card-list-jobtype col-12 col-md-auto">
          <svg style="vertical-align: -0.129em;" xmlns="http://www.w3.org/2000/svg" width="20" height="21"
               fill="currentColor" viewBox="0 0 16 16">
            <path
              d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z"/>
            <path
              d="M3 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m0-5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z"/>
          </svg>
          <span> {{ Utils.getJobType(job.contract_type) }}</span>
        </div>
        <div class="custom-card-list-anstellungsart col-5 col-md-auto">
          <fa-icon [icon]="time"></fa-icon>
          <span> {{ job.timemodel ? "Vollzeit" : "Teilzeit" }}</span>
        </div>
        <div class="custom-card-list-salary col-4 col-md-auto" *ngIf="job.salary">
          <fa-icon [icon]="salary"></fa-icon>
          <span> {{ job.salary }}</span>
        </div>
        <div class="custom-card-list-publishingdate col-5 col-md-auto">
          <fa-icon [icon]="publishingdate"></fa-icon>
          <span> {{ Utils.getDateFormated(job.start_date) }}</span>
        </div>
        <div class="col-4 col-md-auto">
          <fa-icon [icon]="industryicon"></fa-icon>
          <span> {{ this.industry?.at(job.industry-1)!.displayname }}</span>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-auto">
          <a routerLink="/job/{{job.uuid}}" class="ms-2">Weitere Details
            <fa-icon [icon]="arrowright"></fa-icon>
          </a>
        </div>
        <div class="col-auto">
          <span class="ms-2">Veröffentlicht am {{ Utils.getDateFormated(job.publishing_date) }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-1"></div>

</div>

<div class="row w-75 mx-auto text-center p-5" *ngIf="this.apierror">
  <h1>Aktuell können leider keine Daten abgerufen werden, bitte probieren Sie es später erneut</h1>
</div>

